/**
 * Выполнять функцию не более одного раза,
 * пока не превышен интервал между вызовами
 * @param {Function} func
 * @param {number=100} threshold
 * @param {boolean=false} atBeginning
 * @returns {Function}
 */
export default function debounce(
	func: ( ...rest: any[] ) => any,
	threshold: number = 100,
	atBeginning: boolean = false
): ( ...rest: any[] ) => any
{
	var timerId: number;
	
	return function debounced( ...rest: any[] ): void
	{
		if ( timerId )
		{
			clearTimeout( timerId );
		}
		else if ( atBeginning )
		{
			func.apply( this, rest );
		}
		
		timerId = setTimeout(
			() =>
			{
				if ( !atBeginning )
				{
					func.apply( this, rest );
				}
				
				timerId = 0;
			},
			threshold
		);
	}
}
